<div class="close-x">
    <button cdkFocusInitial aria-label="Close dialog" (click)="closeClick()" [ngClass]="{'close-modal-button': isActivityModal && closeAutoFocus}">
        <xm-media-image [imageOptions]="imageOptions" size="width"></xm-media-image>
    </button>
</div>
